// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-bar {\n  padding-top: 15px;\n}\n.table {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.v-data-table__expanded__content {\n  box-shadow: none !important;\n}\n.active-step {\n  background-color: #ffcc00 !important;\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n}\n.active-step {\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
